import { Subject } from 'rxjs';

export const START_NODE = {
    guid: 'Start',
    name: 'Start',
    type: 'root',
};

export const END_NODE = {
    guid: 'tamalego',
    id: 'tamalego'
};

export enum NodeEventType {
    blurNode,
    clickNode,
    addkNode,
    clickNoteMeatball,
    deleteNodes,
    enterNode
}

export enum NodeActionType {
    refresh,
    closeContextMenu
}

export class DiagramConfig {
    nodes: Array<any>;
    invalidSetting: boolean;
    actions$: Subject<{ type: NodeActionType, payload?: any }>;
    events$: Subject<{ type: NodeEventType, payload: any }>;
    constructor() {
        this.nodes = [];
        this.invalidSetting = false;
        this.events$ = new Subject();
        this.actions$ = new Subject();
    }
}
